import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import "./Ticker.css";

function Ticker() {
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    // fallback: if createdAt doesn't exist, Firestore will still fetch
    const q = query(collection(db, "ticker"), orderBy("createdAt", "desc"));

    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          text: data.text || "",
          createdAt: data.createdAt || null, // fallback
        };
      });
      setTickerItems(items);
    });

    return () => unsub();
  }, []);

  if (tickerItems.length === 0) return null;

  return (
    <div className="ticker-wrapper">
      <div className="ticker-label">Latest News:</div>
      <div className="ticker">
        <div className="ticker-content">
          {tickerItems.map((item) => (
            <span key={item.id} className="ticker-item">
              📢 {item.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Ticker;
